import { render } from "./TrackingSettingsTab.vue?vue&type=template&id=cb4ab828&ts=true"
import script from "./TrackingSettingsTab.vue?vue&type=script&lang=ts"
export * from "./TrackingSettingsTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__